import { render, staticRenderFns } from "./InformationDialog.vue?vue&type=template&id=c8888fce&scoped=true"
import script from "./InformationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InformationDialog.vue?vue&type=style&index=0&id=c8888fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8888fce",
  null
  
)

export default component.exports